module.exports = __webpack_public_path__ + "Flag-868.3294e626395b3746e6139a9544ab4986.svg";